<template>
  <PageBaseNoHeader class="content-background">
    <router-view></router-view>
  </PageBaseNoHeader>
</template>

<script>
import PageBaseNoHeader from '../Components/PageBaseNoHeader.vue'

export default {
  name: 'SecurityPage',
  components: {PageBaseNoHeader}
}
</script>

<style lang="stylus" scoped>
@import "~@/core/Styles/variables.styl"

.content-background
  background-color color-32
  min-height calc(100vh)
</style>
